import React from 'react';
import {
  Radio, RadioGroup, FormControlLabel, Typography, Card, CardContent,
} from '@material-ui/core';
import useStyles from './styles';

const FilterCategory = (props) => {
  const { filterValue, onChangeFilter, keys } = props;
  const classes = useStyles();
  const hash = {};
  const newData = keys?.map((item) => ({ name: item.tableName, color: item.color }));
  const result = newData?.filter((item) => {
    const exist = !hash[item.name];
    hash[item.name] = true;
    return exist;
  });

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.maintitle}>Filtros</Typography>
        <RadioGroup
          value={filterValue || ''}
          row
          onChange={(event) => onChangeFilter(event, 'filter')}
          className={classes.main}
        >
          <FormControlLabel
            label={<Typography className={classes.titles}>Todos</Typography>}
            control={<Radio />}
            value=""
          />
          {result?.map((item) => (
            <FormControlLabel
              key={Math.random()}
              label={(
                <Typography className={classes.titles}>
                  {item?.name.replaceAll('_', ' ')}
                </Typography>
              )}
              control={<Radio style={{ color: item.color }} />}
              value={item.name}
            />
          ))}
        </RadioGroup>
      </CardContent>
    </Card>
  );
};

export default FilterCategory;
